export function assertApiUrl(apiUrl: string | undefined) {
  if (!apiUrl || apiUrl.trim() === '' || apiUrl === '/') {
    throw new Error('VITE_API_URL is not set or invalid (empty or "/")');
  }

  try {
    const url = new URL(apiUrl);
    if (!url.protocol.startsWith('http')) {
      throw new Error();
    }
  } catch {
    throw new Error(`VITE_API_URL is invalid: "${apiUrl}"`);
  }
}
